import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'searchPipe' })
export class SearchPipe implements PipeTransform {
  transform(
    data,
    searchValue: string,
    parameter = '',
    stateFilter: string[] = [],
  ) {
    let returnData = data;
    if (searchValue) {
      returnData = returnData.filter((val) => {
        return (
          val[parameter].toLowerCase().indexOf(searchValue.toLowerCase()) > -1
        );
      });
    }
    if (stateFilter.length) {
      returnData = returnData.filter((val) => {
        return stateFilter.includes(val.status);
      });
    }
    return returnData;
  }
}
